module.exports = __webpack_public_path__ + "img/provincia.bd867b5b.png";